var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{staticClass:"mr-4",attrs:{"label":_vm.valueItem.label,"error-messages":_vm.validationErrors,"stack-label":"","outlined":"","dense":""},on:{"input":_vm.emitInputEvent},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }